import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import logo from '../Image/logo.png'

function IciciUpiPay() {
    const [copied, setCopied] = useState(false)
    const mobileNumber = '9716412565'
    const pdfUrl = '/Files/ICICI_UPI_QR.pdf'

    useEffect(() => {
        // Ensure browser tab title and favicon are properly set
        document.title = 'ICICI Bank / UPI QR - ND Techland Pvt. Ltd.'
        let favicon = document.querySelector("link[rel*='icon']")
        if (!favicon) {
            favicon = document.createElement('link')
            favicon.rel = 'icon'
            document.head.appendChild(favicon)
        }
        favicon.href = '/images/favicon.ico'
    }, [])

    const handleCopy = () => {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(mobileNumber)
            setCopied(true)
            setTimeout(() => setCopied(false), 2500)
        } else {
            const textArea = document.createElement('textarea')
            textArea.value = mobileNumber
            document.body.appendChild(textArea)
            textArea.select()
            document.execCommand('copy')
            document.body.removeChild(textArea)
            setCopied(true)
            setTimeout(() => setCopied(false), 2500)
        }
    }

    return (
        <div style={{ minHeight: '100vh', background: '#f8fafc', fontFamily: "'Inter', system-ui, -apple-system, sans-serif" }}>
            {/* Header */}
            <header style={{
                background: '#ffffff',
                borderBottom: '1px solid #e2e8f0',
                padding: '16px 24px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.03)',
                position: 'sticky',
                top: 0,
                zIndex: 100
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <Link to="/" style={{ textDecoration: 'none' }}>
                        <img src={logo} alt="ND Techland" style={{ height: '44px' }} />
                    </Link>
                    <span style={{
                        background: '#fff7ed',
                        color: '#c2410c',
                        border: '1px solid #fed7aa',
                        padding: '4px 10px',
                        borderRadius: '50px',
                        fontSize: '11px',
                        fontWeight: '700',
                        letterSpacing: '0.3px',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px'
                    }}>
                        <i className="fas fa-university"></i> OFFICIAL ICICI BANK / UPI GATEWAY
                    </span>
                </div>
                <Link to="/" style={{
                    color: '#64748b',
                    textDecoration: 'none',
                    fontSize: '14px',
                    fontWeight: '600',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    padding: '8px 14px',
                    borderRadius: '8px',
                    transition: 'background 0.2s',
                    background: '#f1f5f9'
                }}>
                    <i className="fas fa-arrow-left"></i> Return to Website
                </Link>
            </header>

            {/* Main Content */}
            <div style={{ maxWidth: '1100px', margin: '40px auto', padding: '0 20px' }}>

                <div style={{ textAlign: 'center', marginBottom: '36px' }}>
                    <h1 style={{ fontSize: '32px', fontWeight: '800', color: '#0f172a', margin: '0 0 8px', letterSpacing: '-0.5px' }}>
                        Scan &amp; Pay via UPI
                    </h1>
                    <p style={{ fontSize: '16px', color: '#64748b', margin: 0, maxWidth: '600px', marginX: 'auto' }}>
                        Use any trusted UPI app like Google Pay, PhonePe, Paytm, BHIM or iMobile Pay to instantly settle your project invoice.
                    </p>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))', gap: '30px', alignItems: 'start' }}>

                    {/* Left Card: QR Display */}
                    <div style={{
                        background: '#ffffff',
                        borderRadius: '24px',
                        boxShadow: '0 20px 40px -15px rgba(0, 0, 0, 0.08), 0 0 1px 1px rgba(0, 0, 0, 0.04)',
                        overflow: 'hidden',
                        border: '2px solid #fed7aa'
                    }}>
                        <div style={{
                            background: 'linear-gradient(135deg, #004b87 0%, #003366 100%)',
                            padding: '20px',
                            textAlign: 'center',
                            color: '#ffffff',
                            borderBottom: '4px solid #f37021'
                        }}>
                            <h3 style={{ margin: '0 0 4px', fontSize: '18px', fontWeight: '700', letterSpacing: '0.5px', textTransform: 'uppercase' }}>
                                ICICI Bank · UPI Accepted Here
                            </h3>
                            <p style={{ margin: 0, fontSize: '12px', color: '#93c5fd' }}>
                                Scan QR code directly using your camera or payment app
                            </p>
                        </div>

                        {/* PDF Embed Frame */}
                        <div style={{ padding: '20px', background: '#f8fafc', textAlign: 'center' }}>
                            <div style={{
                                background: '#ffffff',
                                borderRadius: '16px',
                                border: '1px solid #cbd5e1',
                                overflow: 'hidden',
                                height: '540px',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                                marginBottom: '16px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <object
                                    data={pdfUrl}
                                    type="application/pdf"
                                    width="100%"
                                    height="100%"
                                    style={{ border: 'none' }}
                                >
                                    <embed src={pdfUrl} type="application/pdf" width="100%" height="100%" />
                                    <div style={{ padding: '30px', color: '#475569', textAlign: 'center' }}>
                                        <i className="fas fa-qrcode" style={{ fontSize: '64px', color: '#f37021', marginBottom: '16px', display: 'block' }}></i>
                                        <h4 style={{ margin: '0 0 8px', color: '#0f172a', fontSize: '18px' }}>ICICI Bank UPI QR Code</h4>
                                        <p style={{ fontSize: '13px', color: '#64748b', marginBottom: '20px' }}>
                                            Your browser preview mode requires downloading to view the QR document directly.
                                        </p>
                                        <a
                                            href={pdfUrl}
                                            download="ICICI_UPI_QR.pdf"
                                            style={{
                                                display: 'inline-block',
                                                padding: '10px 20px',
                                                background: '#f37021',
                                                color: '#fff',
                                                textDecoration: 'none',
                                                borderRadius: '8px',
                                                fontWeight: '700'
                                            }}
                                        >
                                            <i className="fas fa-download"></i> Download QR Code PDF
                                        </a>
                                    </div>
                                </object>
                            </div>

                            <div style={{ display: 'flex', gap: '10px' }}>
                                <a
                                    href={pdfUrl}
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{
                                        flex: 1,
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '8px',
                                        padding: '12px 16px',
                                        background: '#004b87',
                                        color: '#ffffff',
                                        textDecoration: 'none',
                                        borderRadius: '12px',
                                        fontWeight: '700',
                                        fontSize: '13px',
                                        boxShadow: '0 6px 16px rgba(0, 75, 135, 0.25)',
                                        transition: 'all 0.2s'
                                    }}
                                >
                                    <i className="fas fa-external-link-alt"></i> Open Full Screen
                                </a>
                                <a
                                    href={pdfUrl}
                                    download="ICICI_UPI_QR.pdf"
                                    style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '6px',
                                        padding: '12px 16px',
                                        background: '#f1f5f9',
                                        color: '#334155',
                                        textDecoration: 'none',
                                        borderRadius: '12px',
                                        fontWeight: '700',
                                        fontSize: '13px',
                                        border: '1px solid #e2e8f0',
                                        transition: 'all 0.2s'
                                    }}
                                >
                                    <i className="fas fa-download"></i> Download
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Right Card: Merchant Info & Guide */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>

                        {/* Merchant Details Box */}
                        <div style={{
                            background: '#ffffff',
                            borderRadius: '24px',
                            padding: '28px',
                            boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.05), 0 0 1px 1px rgba(0, 0, 0, 0.04)',
                            border: '1px solid #e2e8f0'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px', paddingBottom: '16px', borderBottom: '1px solid #f1f5f9' }}>
                                <div>
                                    <span style={{ color: '#16a34a', fontWeight: '700', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <i className="fas fa-check-circle"></i> VERIFIED BUSINESS ACCOUNT
                                    </span>
                                    <h2 style={{ fontSize: '20px', fontWeight: '800', color: '#0f172a', margin: '4px 0 0' }}>
                                        N D TECHLAND PRIVATE LIMITED
                                    </h2>
                                </div>
                            </div>

                            {/* Mobile Number Copy section */}
                            <div style={{ background: '#f8fafc', border: '1px dashed #cbd5e1', borderRadius: '16px', padding: '18px', marginBottom: '24px' }}>
                                <small style={{ display: 'block', fontSize: '12px', color: '#64748b', fontWeight: '600', textTransform: 'uppercase', marginBottom: '6px' }}>
                                    Registered Mobile Number (Direct UPI Pay)
                                </small>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <span style={{ fontSize: '22px', fontWeight: '800', color: '#004b87', letterSpacing: '1px' }}>
                                        9716412565
                                    </span>
                                    <button
                                        onClick={handleCopy}
                                        style={{
                                            background: copied ? '#16a34a' : '#f37021',
                                            color: '#ffffff',
                                            border: 'none',
                                            padding: '8px 16px',
                                            borderRadius: '8px',
                                            fontWeight: '700',
                                            fontSize: '13px',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px',
                                            transition: 'background 0.2s',
                                            boxShadow: copied ? '0 4px 12px rgba(22, 163, 74, 0.3)' : '0 4px 12px rgba(243, 112, 33, 0.3)'
                                        }}
                                    >
                                        <i className={copied ? "fas fa-check" : "fas fa-copy"}></i>
                                        {copied ? 'Copied Number!' : 'Copy Number'}
                                    </button>
                                </div>
                            </div>

                            {/* Accepted Apps */}
                            <div>
                                <small style={{ display: 'block', fontSize: '12px', color: '#64748b', fontWeight: '700', textTransform: 'uppercase', marginBottom: '12px' }}>
                                    Supported Applications &amp; Wallets
                                </small>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                    {['Google Pay', 'PhonePe', 'Paytm', 'BHIM', 'iMobile Pay', 'Pockets', 'Amazon Pay'].map((app, index) => (
                                        <span key={index} style={{
                                            background: '#f1f5f9',
                                            color: '#334155',
                                            padding: '6px 14px',
                                            borderRadius: '50px',
                                            fontSize: '12px',
                                            fontWeight: '600',
                                            border: '1px solid #e2e8f0'
                                        }}>
                                            <i className="fas fa-wallet" style={{ color: '#f37021', marginRight: '5px' }}></i>
                                            {app}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Step by Step Guide */}
                        <div style={{
                            background: '#ffffff',
                            borderRadius: '24px',
                            padding: '28px',
                            boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.05), 0 0 1px 1px rgba(0, 0, 0, 0.04)',
                            border: '1px solid #e2e8f0'
                        }}>
                            <h3 style={{ fontSize: '16px', fontWeight: '800', color: '#0f172a', margin: '0 0 16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <i className="fas fa-info-circle" style={{ color: '#004b87' }}></i>
                                4 Simple Steps to Pay via UPI
                            </h3>

                            <ol style={{ margin: 0, paddingLeft: '20px', color: '#475569', fontSize: '14px', lineHeight: '1.8' }}>
                                <li style={{ marginBottom: '8px' }}><strong>Open any UPI App</strong> on your mobile smartphone.</li>
                                <li style={{ marginBottom: '8px' }}>Select <strong>'Scan QR Code'</strong> or <strong>'Send Money to Mobile Number'</strong>.</li>
                                <li style={{ marginBottom: '8px' }}>Scan the QR code on this page or input number <strong>9716412565</strong>.</li>
                                <li>Enter billing amount, check verified name (N D TECHLAND PRIVATE LIMITED) and complete transaction.</li>
                            </ol>

                            <div style={{ marginTop: '20px', paddingTop: '16px', borderTop: '1px solid #f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'space-between', color: '#64748b', fontSize: '12px' }}>
                                <span style={{ fontWeight: '600', color: '#004b87' }}>Powered by eazypay · ICICI Bank</span>
                                <span style={{ display: 'flex', alignItems: 'center', gap: '4px', color: '#16a34a' }}>
                                    <i className="fas fa-lock"></i> 256-Bit Bank Encryption
                                </span>
                            </div>
                        </div>

                    </div>

                </div>

            </div>
        </div>
    )
}

export default IciciUpiPay
